import React, { useCallback } from 'react';
import { useAuth } from './useAuth';

const api = process.env.REACT_APP_API_URL

export const useApi = () => {

	const {  getAccessToken } = useAuth()

	const [loading, setLoading] = React.useState(true)

	const Fetch = async (route, method = 'GET', payload, json = true) => {
		setLoading(true)
		const headers = {
			Authorization: `Bearer ${getAccessToken()}`,
			"X-API-Key": process.env.REACT_APP_API_KEY
			//jwtToken: getAccessToken()
		}

		if (json) {
			headers['Content-Type'] = 'application/json'
		}

		return await fetch(`${api}/auth${route}`, {
			headers: { ...headers },
			method: method,
			body: json ? JSON.stringify(payload) : payload
		})
			.then(async (response) => {
				if (!response.ok) {
					if (response.status === 403) {
						// return await getAuthorization().then(() => Fetch(route, method = 'GET', payload, json = true))
					}
				}
				return await response.json()
			})
			.then(async (data) => {
				setLoading(false)
				return await data
			})
			.catch((error) => {
				setLoading(false)
				console.log(error)
			});
	}
	const FetchText = async (route, method = 'GET') => {
		setLoading(true)
		const headers = {
			Authorization: `Bearer ${getAccessToken()}`,
			"X-API-Key": process.env.REACT_APP_API_KEY,
			//jwtToken: getAccessToken(),
			'Content-Type':'text/csv'
		}



		return await fetch(`${api}/auth${route}`, {
			headers: { ...headers },
			method: method,
		})
			.then(async (response) => {
				if (!response.ok) {					
					if (response.status === 403) {
						//return await getAuthorization().then(() => FetchText(route, method = 'GET'))
					}
				}
				return await response.text()
			})
			.then(async (data) => {
				setLoading(false)
				return await data
			})
			.catch((error) => {
				setLoading(false)
				console.log(error)
			});
	}
	const FetchCSV = async (route, method = 'GET', fallbackFilename = 'download.csv') => {
		setLoading(true);
		const headers = {
		  Authorization: `Bearer ${getAccessToken()}`,
		  "X-API-Key": process.env.REACT_APP_API_KEY,
		  'Content-Type': 'text/csv',
		};
	  
		try {
		  const response = await fetch(`${api}/auth${route}`, {
			headers: { ...headers },
			method: method,
		  });
	  
		  if (!response.ok) {
			if (response.status === 403) {
			  // Gérer l'authentification ici si nécessaire.
			} else {
			  throw new Error('La requête a échoué');
			}
		  }
	  
		  const blob = await response.blob();
		  const contentDisposition = response.headers.get('Content-Disposition');
		  const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
		  const matches = filenameRegex.exec(contentDisposition);
		  const filename = matches && matches[1] ? matches[1].replace(/['"]/g, '') : fallbackFilename;
	  
		  const url = window.URL.createObjectURL(blob);
		  const a = document.createElement('a');
		  a.style.display = 'none';
		  a.href = url;
		  a.download = filename;
		  document.body.appendChild(a);
		  a.click();
		  window.URL.revokeObjectURL(url);
	  
		  setLoading(false);
		} catch (error) {
		  setLoading(false);
		  console.error(error);
		}
	  };
	  
	const FetchUrl = async (route, method = 'GET') => {
		setLoading(true)
		const headers = {
			Authorization: `Bearer ${getAccessToken()}`,
			"X-API-Key": process.env.REACT_APP_API_KEY,
			//jwtToken: getAccessToken(),
			'Content-Type':'text/csv'
		}



		return await fetch(`${route}`, {
			headers: { ...headers },
			method: method,
		})
			.then(async (response) => {
				if (!response.ok) {					
					if (response.status === 403) {
						//return await getAuthorization().then(() => FetchText(route, method = 'GET'))
					}
				}
				return await response.text()
			})
			.then(async (data) => {
				setLoading(false)
				return await data
			})
			.catch((error) => {
				setLoading(false)
				console.log(error)
			});
	}

	const FetchBlob = useCallback(async (route, method = 'GET',noAuth = false) => {
		setLoading(true)
		const headers = {
			Authorization: `Bearer ${getAccessToken()}`,
			"X-API-Key": process.env.REACT_APP_API_KEY
			//jwtToken: getAccessToken(),
			//'Content-Type':'text/csv'
		}
		let u = `${api}/auth${route}`
		if (noAuth){
			u =`${api}${route}`
		}
		return await fetch(u, {
			headers: { ...headers },
			method: method,
		})
			.then(async (response) => {
				if (!response.ok) {					
					if (response.status === 403) {
						//return await getAuthorization().then(() => FetchText(route, method = 'GET'))
					}
				}
				return await response.blob()
			})
			.then(async (data) => {
				setLoading(false)
				return await data
			})
			.catch((error) => {
				setLoading(false)
			});
	},[getAccessToken])

	const FetchResponse = useCallback(async (route, method = 'GET',noAuth = false) => {
		setLoading(true)
		const headers = {
			Authorization: `Bearer ${getAccessToken()}`,
			"X-API-Key": process.env.REACT_APP_API_KEY
			//jwtToken: getAccessToken(),
			//'Content-Type':'text/csv'
		}
		let u = `${api}/auth${route}`
		if (noAuth){
			u =`${api}${route}`
		}
		console.log(u)
		return await fetch(u, {
			headers: { ...headers },
			method: method,
		})
			.then(async (response) => {
				if (!response.ok) {					
					if (response.status === 403) {
						//return await getAuthorization().then(() => FetchText(route, method = 'GET'))
					}
				}
				return await response
			})
			.catch((error) => {
				setLoading(false)
			});
	},[getAccessToken])

	const FetchBlobAWS = useCallback(async (route, method = 'GET') => {
		return FetchBlob(`/file?url=${route}`, method)
	},[FetchBlob])

	return { Fetch,FetchText,FetchCSV,FetchUrl,FetchBlob,FetchResponse,FetchBlobAWS, loading };
};